import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import React from 'react';

export interface IFormulaireProps {
    valueSousModule: any;
    setValueSousModule: any;
}

const Formulaire = (props: IFormulaireProps) => {


    const {
        valueSousModule,
        setValueSousModule
    } = props


    return (
        <div>
            <Grid container spacing={2}>
                <Grid item md={12} xs={12} sm={12}>
                    <TextField
                        label="Sous module"
                        fullWidth
                        required
                        margin="dense"
                        size="small"
                        type="text"
                        variant="standard"
                        name="valueSousModule"
                        value={valueSousModule}
                        onChange={(e) => setValueSousModule(e.target.value)}
                    />
                </Grid>
            </Grid>
        </div>
    );
}
export default Formulaire;
